import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import(/* webpackChunkName: "Index" */ './views/Index.vue'),
      meta: {
        title: 'Veiligheidsteam',
        canonical: 'https://veiligheidsteam.nl'
      }
    },
    {
      path: '/partners',
      name: 'Partners',
      component: () => import(/* webpackChunkName: "Partners" */ './views/Partners.vue'),
      meta: {
        title: 'Partners Veiligheidsteam',
        description: 'Veiligheidsteam.nl werkt samen met gerenomeerde partners voor de beveiliging, medische- en verkeersondersteuning.',
        canonical: 'https://veiligheidsteam.nl/partners'
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import(/* webpackChunkName: "Contact" */ './views/Contact.vue'),
      meta: {
        title: 'Contact Veiligheidsteam',
        canonical: 'https://veiligheidsteam.nl/contact'
      }
    },
    {
      path: '/crowd-management',
      name: 'CrowdManagement',
      component: () => import(/* webpackChunkName: "CrowdManagement" */ './views/CrowdManagement.vue'),
      meta: {
        title: 'Crowd Management',
        canonical: 'https://veiligheidsteam.nl/crowd-management'
      }
    },
    {
      path: '/risk-analysis',
      name: 'RiskAnalysis',
      component: () => import(/* webpackChunkName: "RiskAnalysis" */ './views/RiskAnalysis.vue'),
      meta: {
        title: 'Risico Analyse',
        canonical: 'https://veiligheidsteam.nl/risk-analysis'
      }
    },
  ]
})
